export default {
  thPaddingSmall: '8px',
  thPaddingMedium: '12px',
  thPaddingLarge: '12px',
  tdPaddingSmall: '8px',
  tdPaddingMedium: '12px',
  tdPaddingLarge: '12px',
  sorterSize: '15px',
  resizableContainerSize: '8px',
  resizableSize: '2px',
  filterSize: '15px',
  paginationMargin: '12px 0 0 0',
  emptyPadding: '48px 0',
  actionPadding: '8px 12px',
  actionButtonMargin: '0 8px 0 0'
};